import { Component, Input } from '@angular/core';

import { SyncingProgressSummaryData } from '../../local-seo';

@Component({
  selector: 'local-seo-listings-summary-card',
  templateUrl: './listings-summary-card.component.html',
  styleUrls: ['./listings-summary-card.component.scss'],
  standalone: false,
})
export class ListingsSummaryCardComponent {
  @Input() data: SyncingProgressSummaryData;
}
